<template>
<div class="main-container">
    <!-- 页面标题 -->
    <div class="page-header">
        <h1 class="page-title">监督管理</h1>
    </div>
    <div class="content">
        <div>
      <a-form-model layout="inline" @keyup.enter.native="query" style="margin-bottom: 2vh">
          <div class="form-group-list">
            <div class="form-group">
              <InputField labelWidth="0" ref="inputField1" type="text" id="content" v-model="form.content" placeholder="上报内容"
                          @update:modelValue="(value) => handleModelValueUpdate('content', value)"/>
            </div>
            <div class="form-group">
                <RangePickerField ref="RangePickerField" labelWidth="0" v-model="form.time" :placeholder="['上报开始时间', '上报结束时间']" :disabled="false"
                                  @update:modelValue="(value) => handleModelValueUpdate('time', value)"/>
            </div>
            <div class="form-group">
                <SelectField labelWidth="0" ref="SelectField1" :options="typeList" v-model="form.status" id="status" placeholder="处理状态"
                             @update:modelValue="(value) => handleModelValueUpdate('time', value)"/>
            </div>
            <div class="form-group">
              <a-space>
                  <ButtonField text="查询" @click="query" secondary />
                  <ButtonField text="重置" primary @click="reset"/>
                  <ButtonField text="扫码上报" @click="visible=true" secondary />
              </a-space>
            </div>
          </div>
      </a-form-model>


      <Modal v-if="visible" v-model="visible"
                 :visible="visible"
                 :title="'扫码'"
                 :showFooter="false"
                 :overlayOpacity="0.5"
                 @update:visible="visible = $event"
                 :contentWidth="'20%'"
          >
        <img src="@/assets/supervise/code.png" style="width:100%;" />
      </Modal>
      <a-divider />

        <Tablelist
                style="margin-top: 1rem"
                :showCheckbox="false"
                :list="list"
                :columns="tableColumns"
                :totalSize="totalSize"
                :totalPages="totalPages"
                :pageNum="pageNum"
                :pageSize="pageSize"
                @page-change="onChange"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a @click="$router.push(`${$route.path}/detail?id=${item.id}`)">立即处理</a>
                </a-space>
            </template>
        </Tablelist>
    </div>
    </div>
</div>
</template>
<script>
import { fetchList } from "@/api/supervise";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      form: {},
      list: [],
      loading: false,
      total: 0,
      totalSize: 0,
      totalPages: 0,
      pageNum: 1,
      pageSize: 10,
      visible: false,
      tableColumns: [
          {
              key: 'index',
              title: '序号',
              infotype: 'index'
          },
          {
              key: 'content',
              title: '上报内容',
              field: 'content',
              infotype: 'text'
          },
          {
              key: 'reporterContact',
              title: '上报人联系方式',
              field: 'reporterContact',
              infotype: 'text',
          },
          {
              key: 'reporteTime',
              title: '上报时间',
              field: 'reporteTime',
              infotype: 'text',
          },
          {
              key: 'processor',
              title: '处理人',
              field: 'processor',
              infotype: 'text',
          },
          {
              key: 'processTime',
              title: '处理时间',
              field: 'processTime',
              infotype: 'text',
          },
          {
              key: 'remark',
              title: '处理说明',
              field: 'remark',
              infotype: 'text',
          },
          {
              key: 'status',
              title: '状态',
              field: 'text',
              infotype: 'dictType',
              dictType:"superviseStatus"
          },
          {
              key: 'actions',
              title: '操作',
              infotype: 'template',
          }
      ],
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("superviseStatus");
    },
  },
  methods: {
    moment,
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
    getList() {
      this.loading = true;
      let {  form } = this;
      const { content, status } = form;

      let startTime, endTime;
      if (Array.isArray(form.time) && form.time.length === 2) {
        startTime = form.time[0].format("YYYY-MM-DD HH:mm:ss");
        endTime = form.time[1].format("YYYY-MM-DD HH:mm:ss");
      }

      fetchList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        content,
        status,
        startTime,
        endTime,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
              this.list = res.list;
              this.totalSize = res.totalSize;
              this.totalPages = res.totalPages;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.pageNum  = pagination;
      this.pageSize = 10;
      this.getList();
    },
    reset() {
      this.form = {};
      this.$refs.inputField1.reset();
      this.$refs.RangePickerField.reset();
      this.$refs.SelectField1.reset();
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },
    query() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.main-container {
  padding:2rem 0;
  width: 80%;
  margin: auto;
}
.page-header {
  margin-bottom: 2rem;
}

.page-title {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #fff, #00ff96);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.content{
  background: rgba(20, 35, 70, 0.5);
  border: 1px solid rgba(0, 255, 150, 0.2);
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 1.5rem;
}
.modal {
  width: 250px;
  .ant-modal-body {
    text-align: center;
  }
}

.form-group-list{
  display: flex;
  justify-items: start;
  align-content: center;
}
.form-group{
  margin-right: 1rem;
}
</style>
